import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Scroll down to the `}<strong parentName="p">{`Primary metrics`}</strong>{` section and click `}<strong parentName="p">{`+ Add primary metric`}</strong>{`.`}</p>
    <p>{`Choose `}<strong parentName="p">{`Single-use`}</strong>{` and select `}<strong parentName="p">{`Type`}</strong>{` > `}<strong parentName="p">{`Mean`}</strong>{`.`}</p>
    <p>{`Then search for the event `}<inlineCode parentName="p">{`cta clicked`}</inlineCode>{` under `}<strong parentName="p">{`Metric`}</strong>{` and click `}<strong parentName="p">{`Save`}</strong>{`.`}</p>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/primary_metric_b8d831b522.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/primary_metric_dark_a24636046b.png" alt="Add primary metric" classes="rounded" padding={false} mdxType="ProductScreenshot" />
    <p>{`By default, experiments are exposed to 100% of users. You can customize `}<a parentName="p" {...{
        "href": "/docs/experiments/creating-an-experiment#release-conditions"
      }}>{`release conditions`}</a>{` to expose the experiment to a subset of users. `}</p>
    <p>{`For this tutorial, we'll ship the experiment to all users and click `}<strong parentName="p">{`Launch`}</strong>{` in the top right.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      